export enum FileStatus {
  Updated = 'UPDATED',
  New = 'NEW',
  Active = 'ACTIVE',
  Hide = 'HIDE'
}



// WEBPACK FOOTER //
// ./src/app/models/file-status.enum.ts